import type  { ISong } from "../../services/Entities";
import { ICanvasRenderOptions, IDraw2D } from "../abstraction/IDraw2D";
import { IViewLayer } from "../abstraction/IViewLayer";
import { IDrawStyle } from "../abstraction/IDrawStyle";
import { SEMI_NOTE_SIZE, getNoteFrequencyLog2, getNotes } from "../../helpers/Notes";
import { clipMargins, drawRect, drawWithStyle } from "../../helpers/Draw";
import { Song } from "../../player/Song";

export class SongTrack implements IDraw2D {

    protected _layer: IViewLayer;
    protected _song: Song;
    protected _visible: boolean = true;

    constructor() {

        this.style = {
            fillColor: "#2E7D32"
        };
    }


    attach(layer: IViewLayer) {
        this._layer = layer;
    }

    setSong(song: Song) {
        this._song = song;
        this._layer?.requestRender();
    }

    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        if (!this._song)
            return;

        ctx.save();

        clipMargins(ctx, this._layer.host.margin, options.viewSize);

        ctx.beginPath();

        for (const note of this._song.notes()) 
            drawRect(ctx, note.time, getNoteFrequencyLog2(note.note) - SEMI_NOTE_SIZE/ 2, note.duration, SEMI_NOTE_SIZE);
        

        drawWithStyle(ctx, this.style);

        ctx.restore();
    }

    get visible() {
        return this._visible;
    }

    set visible(value: boolean) {
        this._visible = value;
        this._layer?.requestRender();
    }

    get duration() {
        if (!this._song)
            return 0;
        const lastNote = this._song.note(this._song.length - 1);
        return lastNote.duration + lastNote.time;
    }

    get song() {
        return this._song;
    }

    style: IDrawStyle;
}